(function () {
  'use strict';

  const DEBOUNCE_MS = 350;
  const CONTAINER_ID = 'RecipeGridContainer';
  const SECTION_SEL = '[data-section-render-id][data-blog]';
  const SCROLL_ANCHOR_ID = 'AjaxScrollAnchor';

  let debounceTimer = null;
  let abortController = null;

  const section = document.querySelector(SECTION_SEL);
  const container = document.getElementById(CONTAINER_ID);
  const searchInput = document.querySelector('[data-recipe-search-input]');
  const searchForm = document.querySelector('[data-recipe-search-form]');

  if (!section || !container) return;

  const sectionId = section.getAttribute('data-section-render-id');
  const blogUrl = section.getAttribute('data-blog-url') || ('/blogs/' + section.getAttribute('data-blog'));
  const searchUrl = section.getAttribute('data-search-url') || '/search';
  const perPage = section.getAttribute('data-per-page') || '';
  const mealTypes = (section.getAttribute('data-meal-types') || '')
    .split(',')
    .map(function (m) { return m.trim(); })
    .filter(Boolean);

  const base = blogUrl.replace(/\/$/, '');

  // Mirrors Liquid's handleize of "meal_type:theo randall" -> meal_type-theo-randall.
  function mealHandle(tag) {
    return ('meal_type-' + tag).toLowerCase().replace(/[^a-z0-9_]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function mealFromHandle(handle) {
    for (let i = 0; i < mealTypes.length; i++) {
      if (mealHandle(mealTypes[i]) === handle) return mealTypes[i];
    }
    return '';
  }

  // Browsing goes through the native tagged blog route, which filters before
  // pagination and so covers the whole blog. Searching goes to storefront search
  // via templates/search.recipes.liquid. Neither can run in Liquid on the blog
  // page: blog.articles caps at the 50 most recent articles.
  function browseUrl(tag, page) {
    let url = base;
    if (tag) url += '/tagged/' + mealHandle(tag);
    if (page && page > 1) url += '?page=' + page;
    return url;
  }

  function searchFetchUrl(tag, q, page) {
    const p = new URLSearchParams();
    p.set('q', q);
    p.set('type', 'article');
    p.set('view', 'recipes');
    if (tag) p.set('meal', tag);
    if (perPage) p.set('per_page', perPage);
    if (page && page > 1) p.set('page', page);
    return searchUrl.replace(/\/$/, '') + '?' + p.toString();
  }

  function getFetchUrl(tag, q, page) {
    return q ? searchFetchUrl(tag, q, page) : browseUrl(tag, page);
  }

  // What the address bar shows. A search stays on the blog page so the pills and
  // search box keep their context; browsing uses the real tagged URL.
  function getDisplayUrl(tag, q, page) {
    if (!q) return browseUrl(tag, page);
    const p = new URLSearchParams();
    p.set('q', q);
    if (tag) p.set('meal', tag);
    if (page && page > 1) p.set('page', page);
    return base + '?' + p.toString();
  }

  // Reads {tag, q, page} out of a URL, whether the meal sits in the path
  // (/tagged/meal_type-dinner) or in a query param (search mode).
  function readState(url) {
    const u = new URL(url, window.location.origin);
    const q = (u.searchParams.get('q') || '').trim();
    let tag = u.searchParams.get('meal') || '';
    if (!tag) {
      const m = u.pathname.match(/\/tagged\/([^/?]+)/);
      if (m) tag = mealFromHandle(decodeURIComponent(m[1]));
    }
    return { tag: tag, q: q, page: parseInt(u.searchParams.get('page') || '1', 10) };
  }

  function updateFilterButtons(activeTag) {
    document.querySelectorAll(SECTION_SEL + ' [data-tag]').forEach(function (btn) {
      const btnTag = btn.getAttribute('data-tag');
      const isActive = btnTag === activeTag || (btnTag === '' && !activeTag);
      btn.classList.toggle('filter-btn--active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function syncSearchFormTag(tag) {
    if (!searchForm) return;
    let hidden = searchForm.querySelector('input[name="meal"]');
    if (tag) {
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'meal';
        searchForm.appendChild(hidden);
      }
      hidden.value = tag;
    } else {
      if (hidden) hidden.remove();
    }
  }

  function updateUrl(tag, q, page) {
    history.pushState({ tag: tag, q: q, page: page || 1 }, '', getDisplayUrl(tag, q, page));
  }

  function setLoading(loading) {
    container.classList.toggle('is-loading', !!loading);
  }

  function extractResultsHtml(html) {
    const wrap = document.createElement('div');
    wrap.innerHTML = html;
    const inner = wrap.querySelector('#' + CONTAINER_ID);
    return inner ? inner.innerHTML : html;
  }

  function scrollToResultsTop() {
    // Align with other theme AJAX pagination handlers (header offset)
    const headerOffset = 80;
    const anchor =
      (section && section.querySelector('#' + SCROLL_ANCHOR_ID)) ||
      document.getElementById(SCROLL_ANCHOR_ID) ||
      container;
    const targetTop = anchor.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
  }

  function loadResults(tag, q, page, pushState, skipScroll) {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    setLoading(true);

    fetch(getFetchUrl(tag, q, page), { signal: abortController.signal })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        container.innerHTML = extractResultsHtml(html);
        if (typeof window.initRecipeCards === 'function') window.initRecipeCards();
        if (pushState) updateUrl(tag, q, page);
        updateFilterButtons(tag);
        syncSearchFormTag(tag);

        // Ensure the new layout is in the DOM before scrolling.
        if (!skipScroll) window.requestAnimationFrame(scrollToResultsTop);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        // A search renders from a placeholder, so a hard redirect back to the
        // blog page would just land on the placeholder and retry in a loop.
        if (q) {
          container.innerHTML =
            '<p class="main-recipes_empty text-center text-grey">Sorry, we could not load those recipes. Please try again.</p>';
          return;
        }
        window.location.href = browseUrl(tag, page);
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function handleFilterClick(e) {
    const btn = e.target.closest('a[data-tag]');
    if (!btn) return;
    e.preventDefault();
    const tag = btn.getAttribute('data-tag') || '';
    loadResults(tag, readState(window.location.href).q, 1, true);
  }

  function handleSearchInput() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      const q = (searchInput && searchInput.value.trim()) || '';
      loadResults(readState(window.location.href).tag, q, 1, true);
    }, DEBOUNCE_MS);
  }

  function handleSearchSubmit(e) {
    e.preventDefault();
    const q = (searchInput && searchInput.value.trim()) || '';
    loadResults(readState(window.location.href).tag, q, 1, true);
  }

  function handlePaginationClick(e) {
    const link = e.target.closest('a.pagination__item');
    if (!link || link.closest('#' + CONTAINER_ID) === null) return;
    if (link.hasAttribute('aria-disabled') || link.getAttribute('aria-current')) return;
    e.preventDefault();
    const linkState = readState(link.href);
    // Native tagged pagination links carry the meal in the path; search
    // pagination links carry q. Either way the current tag survives.
    const state = readState(window.location.href);
    loadResults(linkState.tag || state.tag, linkState.q || state.q, linkState.page, true);
  }

  section.addEventListener('click', function (e) {
    if (e.target.closest('a[data-tag]')) { e.preventDefault(); handleFilterClick(e); }
    else if (e.target.closest('.pagination__item')) handlePaginationClick(e);
  });

  if (searchInput) {
    searchInput.addEventListener('input', handleSearchInput);
  }
  if (searchForm) {
    searchForm.addEventListener('submit', handleSearchSubmit);
  }

  // The section renders a placeholder when q is set, so a direct hit on
  // /blogs/recipes?q=… has to pull its own results in. Browsing needs no such
  // kick — the tagged route renders its own results server-side.
  const initial = readState(window.location.href);
  if (initial.q) {
    loadResults(initial.tag, initial.q, initial.page, false, true);
  }

  window.addEventListener('popstate', function () {
    const state = readState(window.location.href);
    if (searchInput) searchInput.value = state.q;
    loadResults(state.tag, state.q, state.page, false);
  });
})();
